import {
  contractorColor,
  contractorKey,
  formatMDY,
  requestTypeStatusColor,
  getStatusColor,
} from "@utils/ptoHelpers";

export function DayEventsPopover({
  dateStr,
  dayList,
  onRequestClick,
  onClose,
  plantFilter = "0",
  statusFilter = "",
  highlightedRequestId,
}: {
  dateStr: string;
  dayList: any[];
  onRequestClick: (request: any) => void;
  onClose: () => void;
  plantFilter?: string;
  statusFilter?: string;
  highlightedRequestId?: number | null;
}) {
  return (
    <div
      className="tw-absolute tw-z-20 tw-right-0 tw-top-5 tw-w-[240px] tw-max-h-[240px] tw-overflow-auto tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-md tw-bg-white dark:tw-bg-[#0D1117] tw-shadow-lg tw-p-2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-1 tw-text-xs tw-text-gray-600 dark:tw-text-gray-300">
        <span>{formatMDY(dateStr)}</span>
        <button
          className="tw-px-1 tw-py-0.5 tw-border tw-rounded tw-text-[10px]"
          onClick={onClose}
        >
          Close
        </button>
      </div>
      <div className="tw-space-y-1">
        {dayList.map((r) => {
          // Use status+type colors when both filters are "All"
          const useDefaultColors = plantFilter === "0" && statusFilter === "";
          const { bg, text } = useDefaultColors
            ? requestTypeStatusColor(r.status, r.request_type)
            : contractorColor(contractorKey(r));

          const contractor =
            r.contractor_name || r.user_email || r.user_id || "";
          const requestTypeText = r.request_type ? ` (${r.request_type})` : "";
          const hoursText =
            typeof r.hours_requested === "number"
              ? ` • ${r.hours_requested}h`
              : "";
          const endStr = String(r.end_date).slice(0, 10);
          const endsHere = endStr === dateStr;

          const statusColorClass = getStatusColor(r.status, r.request_type);
          const statusText = (r.status || "").toString();
          const isHighlighted =
            highlightedRequestId != null && r.id === highlightedRequestId;

          return (
            <div
              key={`pop-${r.id}-${dateStr}`}
              className="tw-cursor-pointer"
              onClick={() => {
                onRequestClick(r);
                onClose();
              }}
            >
              <div
                className={`${bg} ${text} tw-text-[10px]  tw-leading-tight tw-px-1 tw-py-0.5 tw-rounded${
                  isHighlighted
                    ? " tw-ring-2 tw-ring-offset-1 tw-ring-blue-500"
                    : ""
                }`}
                title={`${contractor} • ${
                  r.description || ""
                }${requestTypeText} • ${r.status}${hoursText}`}
              >
                {`${contractor} • ${r.description || ""}${requestTypeText} • `}
                <span
                  className={`tw-font-semibold tw-bg-white tw-px-1 tw-rounded ${statusColorClass}`}
                >
                  {statusText}
                </span>
                {endsHere ? hoursText : ""}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
